import request from '@/request'
import handler from '@/utils/responseHandler'

/*
  日历节假日数据相关接口
  331036    查询假期信息
  331546    查询12306预售天数
*/
export default {
  '331036': () =>
    request.ticket({
      url: '/gateway/gtgj/act',
      data: {
        pid: 331036
      },
      sidFields: ['uid', 'pid']
    }).then(handler.resBdData),

  '331546': () =>
    request.ticket({
      url: '/gateway/gtgj/dyn',
      data: {
        pid: 331546
      },
      sidFields: ['uid', 'pid']
    }).then(handler.resBdData)
}



// WEBPACK FOOTER //
// ./src/api/calendar.js